// src/modules/app-views/account/pages/init/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import React, { useEffect } from 'react';
import useZustand from 'hooks/useZustand';
import { useDocumentContext } from 'components/core/DocumentProvider';
import translateX from 'utils/translateX';
import { Tabs } from 'antd';
import { DatabaseOutlined, UserOutlined } from '@ant-design/icons';
import AccountsMyProfileTab from './tabs/MyProfileTab';
import AccountsSubscriptionsTab from './tabs/SubscriptionsTab';
import BackToHomeLink from 'components/core/BackToHomeLink';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const AccountInit = props => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { tab, handleTabChange, availableTabs, buildTabs } = useDocumentContext();
  const storedSubscription = useZustand('auth', 'subscription');
  const storedLanguage = useZustand('theme', 'language');

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────
  // Note: useApi() is not needed here because each tab calls it

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────
  useEffect(() => {
    // CRITICAL: Skip buildTabs until initTab is available from DocumentProvider
    // This prevents the effect from running before the page settings are loaded,
    // which can cause a loop of re-renders when initTab changes from undefined to a value
    if (!buildTabs) return;

    const childProps = { ...props, storedSubscription };
    const itemsLocal = buildTabsArray(childProps);
    buildTabs(itemsLocal);
  }, [storedLanguage, storedSubscription, buildTabs]);

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <>
      <Tabs
        type="line"
        tabPlacement="top"
        activeKey={tab}
        rootClassName="tab-in-form no-content-padding"
        items={availableTabs}
        onChange={handleTabChange}
        animated={{ inkBar: true, tabPane: false }}
        destroyOnHidden={false}
      />
    </>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default AccountInit;

// *******************************************************************************
// HELPERS
// *******************************************************************************
function buildTabsArray(props) {
  const { storedSubscription } = props;

  return [
    {
      key: 'my_profile',
      label: (
        <>
          <UserOutlined />
          <span>{translateX('my_profile')}</span>
        </>
      ),
      hide: false,
      disabled: false,
      children: <AccountsMyProfileTab {...props} tabName="my_profile" />,
    },
    {
      key: 'subscriptions',
      label: (
        <>
          <DatabaseOutlined />
          <span>{translateX('organizations')}</span>
        </>
      ),
      hide: false,
      disabled: false,
      children: <AccountsSubscriptionsTab {...props} tabName="subscriptions" />,
    },
    // {
    //   key: 'resources',
    //   label: (
    //     <>
    //       <AppstoreAddOutlined />
    //       <span>{translateX('resources')}</span>
    //     </>
    //   ),
    //   hide: storedSubscription?.profile !== 'owner' || !app.ENABLE_MARKETPLACE,
    //   disabled: false,
    //   children: <AccountsResourcesTab {...props} tabName="resources" />,
    // },
    // {
    //   key: 'team',
    //   label: (
    //     <>
    //       <TeamOutlined />
    //       <span>{translateX('team')}</span>
    //     </>
    //   ),
    //   hide: storedSubscription?.profile !== 'owner',
    //   disabled: false,
    //   // children: <ChildTab title="team" tabName="team" />,
    //   children: <AccountsTeamTab {...props} tabName="team" />,
    //   // children: (
    //   //   <ListProviderV2 tabName="team">
    //   //     <AccountsTeamTab {...props} tabName="team" />
    //   //   </ListProviderV2>
    //   // ),
    // },
    // {
    //   key: 'billings',
    //   label: (
    //     <>
    //       <CreditCardOutlined />
    //       <span>{translateX('billings')}</span>
    //     </>
    //   ),
    //   hide: storedSubscription?.profile !== 'owner',
    //   disabled: false,
    //   children: <ChildTab title="billing" tabName="billings" />,
    // },
    // {
    //   key: 'whatsapp',
    //   label: (
    //     <>
    //       <WhatsAppOutlined />
    //       <span>{translateX('whatsapp')}</span>
    //     </>
    //   ),
    //   hide:
    //     !app.WHATSAPP_INTEGRATED ||
    //     !storedSubscription?._id ||
    //     storedSubscription?.profile === 'guest',
    //   disabled: false,
    //   children: <h1>Whatsapp</h1>,
    // },
    // {
    //   key: 'integration',
    //   label: (
    //     <>
    //       <ApiOutlined />
    //       <span>{translateX('integration')}</span>
    //     </>
    //   ),
    //   hide: !app.API_INTEGRATED || !storedSubscription?._id,
    //   disabled: false,
    //   children: <h1>INTEGRATION</h1>,
    // },
  ];
}
